const removeBrandName = (string) => {
  const pattern = /Gilly Hicks |Social Tourist /g;

  return string.replace(pattern, '').trim();
};

export default removeBrandName;
